import React, { useContext, useCallback } from 'react';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import CreateDeveloperModalState from './CreateDeveloperModal/createDeveloperModalContext/createDeveloperModalState/CreateDeveloperModalState';
import EditDeveloperModalState from './EditDeveloperModal/editDeveloperModalContext/editDeveloperModalState/EditDeveloperModalState';
import CreateDeveloperModal from './CreateDeveloperModal/CreateDeveloperModal';
import EditDeveloperModal from './EditDeveloperModal/EditDeveloperModal';
import {
	GameDevelopersContext,
	IGameDevelopersContext,
} from 'modules/Entertainment/Games/GameDevelopers/gameDevelopersState/gameDevelopersContext';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const { deleteSelectedItem, changeTypeOfModalWindow, typeOfModalWindow } =
		useContext<IGameDevelopersContext>(GameDevelopersContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const handleChangeTypeOfModalWindow = useCallback(() => changeTypeOfModalWindow(null), [changeTypeOfModalWindow]);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={deleteSelectedItem}
				onFailureEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'toConfirmDeleteItem'}
				description="deleteDeveloper"
				typeOfInfoIcon="toDelete"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'success'}
				description="deleteDeveloperSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleChangeTypeOfModalWindow}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileDeletingDeveloper"
			/>
			<CreateDeveloperModalState>
				<CreateDeveloperModal isVisible={typeOfModalWindow === 'createDeveloper'} />
			</CreateDeveloperModalState>
			<EditDeveloperModalState>
				<EditDeveloperModal isVisible={typeOfModalWindow === 'editDeveloper'} />
			</EditDeveloperModalState>
		</div>
	);
};

export default ModalWindows;
